export { default } from "./SwiperLive"
